import React, { useState, useEffect, ReactNode } from 'react';
import { GetServerSidePropsContext } from 'next';
import Head from 'next/head';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useAuth } from '../context/AuthUserContext';
import BillingAccountListed from '../components/molecules/BillingAccountListed';
import Section from '../components/organisms/Section';
import Button from '../components/atoms/Button';
import Empty from '../components/atoms/Empty';
import Offset from '../components/organisms/Offset';
import UserForm from '../components/organisms/UserForm';
import BillingForm from '../components/organisms/BillingForm';
import Icon from '../components/atoms/Icon';
import PageDefault from '../components/templates/PageDefault';
import { localeFiles } from '../data/constants';
import styles from '../styles/pages/MyAccount.module.scss';

const MyAccountPage = () => {
  const { t } = useTranslation(['common', 'pages']);
  const [layer, setLayer] = useState<any>(undefined);
  const { user, getUser } = useAuth();
  const billingAccounts = user?.billing_accounts || [];

  const onSubmit = async () => {
    setLayer({});
    await getUser();
  };

  return (
    <>
      <Head>
        <title>{t('pages:my-account:title')}</title>
        <meta name="description" content={t('pages:my-account:description')} />
      </Head>

      <PageDefault authOnly className={styles.myAccountPage} layer={layer}>
        <Section
          hero
          h={t('pages:my-account:hero')}
          prepend={
            <small>
              <Icon name="account" />
              {t('pages:my-account:title')}
            </small>
          }
        />

        <Row>
          <UserForm />
        </Row>

        {/* BillingAccount */}
        <Row>
          <Col xs={8}>
            <br />
            <br />
            <br />
            <h2>{t('pages:my-account:billing-accounts')}</h2>
          </Col>
          {!!billingAccounts.length ? (
            <Col>
              <Offset>
                {billingAccounts.map((el: any, i: number) => (
                  <BillingAccountListed
                    float
                    key={i}
                    data={el}
                    onClick={() =>
                      setLayer(
                        <BillingForm
                          deletable={billingAccounts.length > 1}
                          prefill={el}
                          onCancel={() => setLayer(undefined)}
                          onSubmit={onSubmit}
                        />
                      )
                    }
                  />
                ))}
              </Offset>
            </Col>
          ) : (
            <Col>
              <Empty label={t('pages:my-account:no-accounts-added')} />
            </Col>
          )}
        </Row>

        {/* {!billingAccounts.length &&  */}
        <Row>
          <Col sm={4} md={3} lg={2}>
            <br />
            <Button
              dark
              small
              iconLarge
              icon="plus"
              label={t('pages:my-account:cta-add-account')}
              onClick={() =>
                setLayer(
                  <BillingForm
                    prefill={{ user_id: user?.id }}
                    onCancel={() => setLayer(undefined)}
                    onSubmit={onSubmit}
                  />
                )
              }
            />
          </Col>
        </Row>
        {/* } */}

        <Row>
          <Col>
            <br /> <br />
            <br /> <br />
            <br /> <br />
          </Col>
        </Row>
      </PageDefault>
    </>
  );
};

export async function getServerSideProps(context: GetServerSidePropsContext) {
  const { locale } = context;
  return {
    props: {
      ...(await serverSideTranslations(locale!, localeFiles)),
    },
  };
}

export default MyAccountPage;
